import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../utilities/text-helpers/index.js';
import { Tab } from '../../molecules/tabs/tab.js';
import css_248z from './file-download.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
class FileDownload extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.divider = false;
        this.columns = 1;
        this.blockWidth = 0;
        this.headingSlot = null;
    }
    setBlockWidth(tabsContainer) {
        const content = tabsContainer === null || tabsContainer === void 0 ? void 0 : tabsContainer.shadowRoot.querySelector('.content');
        this.blockWidth = content.offsetWidth;
    }
    setColumns(element) {
        var _a;
        this.blockWidth = element.offsetWidth;
        if (this.parentNode instanceof Tab) {
            const parentTab = this.parentNode;
            const tabsContainer = parentTab.parentElement;
            this.setBlockWidth(tabsContainer);
        }
        if ((_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.classList.contains('accordion-inner')) {
            const tabsContainer = this.parentElement.closest('tabs-container');
            if (tabsContainer)
                this.setBlockWidth(tabsContainer);
        }
        this.columns = 1;
        if (this.blockWidth > 719 && window.innerWidth > 767)
            this.columns = 2;
        if (this.blockWidth > 1256 && window.innerWidth > 1365)
            this.columns = 3;
        if (this.blockWidth > 1758 && window.innerWidth > 1919)
            this.columns = 4;
        const downloadItems = Array.from(element.querySelectorAll('file-download-item'));
        downloadItems.forEach(item => {
            var _a;
            const el = (_a = item.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.file-download-item');
            el === null || el === void 0 ? void 0 : el.setAttribute('data-in-row', `${this.columns}`);
        });
    }
    _addEventListeners() {
        window.addEventListener('resize', () => this.setColumns(this.element));
        window.addEventListener('load', () => this.setColumns(this.element));
    }
    _removeEventListeners() {
        window.removeEventListener('resize', () => this.setColumns(this.element));
        window.removeEventListener('load', () => this.setColumns(this.element));
    }
    connectedCallback() {
        super.connectedCallback();
        this._addEventListeners();
    }
    disconnectedCallback() {
        this._removeEventListeners();
    }
    firstUpdated() {
        var _a;
        this.element = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.file-download__container');
        setDataAttributes(this, 'headline-title', null);
        setLineClamp(this, 80, null);
    }
    render() {
        var _a;
        return x `<div class="file-download ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''} ${this.divider ? 'divider' : ''}" ${this.rtl || isRTL() ? 'rtl' : ''}><hr class="file-download__separator"><slot name="headline-title"></slot><div class="file-download__container columns-${this.columns}"><slot name="file-download-item"></slot></div></div>`;
    }
}
FileDownload.styles = [LitElementWithUtils.styles || [], css_248z];
__decorate([
    n({ type: Boolean })
], FileDownload.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], FileDownload.prototype, "divider", void 0);
__decorate([
    t()
], FileDownload.prototype, "columns", void 0);
__decorate([
    t()
], FileDownload.prototype, "blockWidth", void 0);
__decorate([
    t()
], FileDownload.prototype, "element", void 0);
__decorate([
    t()
], FileDownload.prototype, "headingSlot", void 0);
customElements.define('file-download', FileDownload);

export { FileDownload };
